"use client";

import { APP } from "@idss/libraries";
import { Stack } from "@mantine/core";
import { yupResolver } from "@mantine/form";
import { useCookies } from "next-client-cookies";
import { object, ref, string } from "yup";

import {
  FormProvider,
  useForm,
} from "@/components/staff/forgot-password/password-reset-form-context";
import { RequestOTP } from "@/components/staff/forgot-password/request-otp";
import { ResetPassword } from "@/components/staff/forgot-password/reset-password";

const schema = object({
  email: string().email("Invalid email address").required("Email is required"),
  otp: string().when("reset_password", {
    is: false,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required("OTP is required"),
  }),
  password: string().when("reset_password", {
    is: false,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required("Password is required"),
  }),
  confirm_password: string()
    .oneOf([ref("password")], "Passwords must match")
    .when("reset_password", {
      is: false,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required("Please confirm your password"),
    }),
});

export default function Page() {
  const cookies = useCookies();

  const email = cookies.get(APP.EMAIL) || "";

  const form = useForm({
    initialValues: {
      email,
      otp: "",
      password: "",
      confirm_password: "",
      reset_password: false,
    },
    validate: yupResolver(schema),
    validateInputOnBlur: true,
  });

  return (
    <Stack gap={56} flex={1}>
      <FormProvider form={form}>
        {form.values.reset_password ? <ResetPassword /> : <RequestOTP />}
      </FormProvider>
    </Stack>
  );
}
